import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { ArapExtractChargesType,ArapExtractChargesRequestType } from "@feature/types/arapextractchargestype"

import { ENV } from "@app/constants/env";
import { getToken } from '@app/helpers/authProvider';
import { PLReportEntity, PLReportRequestType } from '@feature/types/plreportentity';

import { SpecificationType, SpecificationChargesType } from '@feature/types/specificationtype';
import { SapExtractEntity } from '@feature/types/sapextractentity.type';
import { SapExtract } from '@feature/types/sapextract.type';
const rawBaseQuery = fetchBaseQuery({
  baseUrl: ENV.BASE_API_URL +ENV.FINANCE_APIURL,
});

const authBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  incomingArgs,
  api,
  extraOptions
) => {
  let args: string | FetchArgs = incomingArgs;

  // normalize string arg to object so we can set headers
  if (typeof args === 'string') {
    args = { url: args };
  }

  try {
    const token = await getToken(); // ensure this returns a non-empty string
    if (token) {
      const headers =
        (args as FetchArgs).headers instanceof Headers
          ? (args as FetchArgs).headers
          : new Headers((args as FetchArgs).headers);

      headers.set('Authorization', `Bearer ${token}`); // use standard casing
      (args as FetchArgs).headers = headers;
    }

    const result = await rawBaseQuery(args, api, extraOptions);

    // optional: retry once if unauthorized (adjust getToken refresh logic if available)
    if (result.error && result.error.status === 401 && token) {
      // If you have a refresh flow, invoke it here then retry.
      // const refreshed = await getRefreshedToken();
      // if (refreshed) { headers.set('Authorization', `Bearer ${refreshed}`); return rawBaseQuery(args, api, extraOptions); }
    }

    return result;
  } catch {
    return { error: { status: 500, data: 'Token retrieval failed' } } as any;
  }
};

export interface ApiResponse<T> {
  success: boolean
  message?: string
  data?: T
  error?: string
}





export const arapreportsapi = createApi({
  reducerPath: 'arapreportsApi',
  baseQuery: authBaseQuery,
  tagTypes: ['finance'],
  endpoints: (builder) => ({

getARInvoiceApproved: builder.mutation<ApiResponse<ArapExtractChargesType[]>, ArapExtractChargesRequestType>({
    query: (dto) => ({
        url: 'FinanceExtractReport/GetARInvioceApproved',
        method: 'POST',
        body: dto,
    }),
    invalidatesTags: ['finance'],
}),
getAPARAccruals: builder.mutation<ApiResponse<ArapExtractChargesType[]>, ArapExtractChargesRequestType>({
  query: (dto) => ({
    url: 'FinanceExtractReport/GetAPARAccruals',
    method: 'POST',
    body: dto,
  }),
  invalidatesTags: ['finance'],
}),


getARInvoiceExtract: builder.mutation<ApiResponse<ArapExtractChargesType[]>, ArapExtractChargesRequestType>({
  query: (dto) => ({
    url: 'FinanceExtractReport/GetARInvioceExtract',
    method: 'POST',
    body: dto,
  }),
  invalidatesTags: ['finance'],
}),
getAPARAccrualsExtract: builder.mutation<ApiResponse<ArapExtractChargesType[]>, ArapExtractChargesRequestType>({
  query: (dto) => ({
    url: 'FinanceExtractReport/GetAPARAccrualsExtract',
    method: 'POST',
    body: dto,
  }),
  invalidatesTags: ['finance'],
}),

getProfitandLossReport: builder.mutation<ApiResponse<PLReportEntity[]>, PLReportRequestType>({
  query: (dto) => ({
    url: 'FinanceExtractReport/GetProfitandLossReport',
    method: 'POST',
    body: dto,
  }),
  invalidatesTags: ['finance'],
}),
getProfitandLossReportExtract: builder.mutation<ApiResponse<PLReportEntity[]>, PLReportRequestType>({
  query: (dto) => ({
    url: 'FinanceExtractReport/GetProfitandLossReportExtract',
    method: 'POST',
    body: dto,
  }),
  invalidatesTags: ['finance'],
}),
getSpecificationReportData: builder.mutation<ApiResponse<SpecificationType>, { woId: number; invoiceId: number }>({
  query: ({ woId, invoiceId }) => ({
    url: `FinanceExtractReport/specificationreportdata/${woId}/${invoiceId}`,
    method: 'POST',
  }),
  invalidatesTags: ['finance'],
}),

getSpecificationChargesReportData: builder.mutation<ApiResponse<SpecificationChargesType>, { invoiceId: number }>({
  query: ({ invoiceId }) => ({
    url: `FinanceExtractReport/specificationchargesreportdata/${invoiceId}`,
    method: 'POST',
  }),
  invalidatesTags: ['finance'],
}),


getARInvoiceApprovedExtractionSAP: builder.mutation<ApiResponse<SapExtractEntity[]>, SapExtract>({
  query: (dto) => ({
    url: 'FinanceExtractReport/GetARInvoiceApprovedExtraction_SAP',
    method: 'POST',
    body: dto,
  }),
  invalidatesTags: ['finance'],
}),

     }),
});

export const {
    useGetARInvoiceApprovedMutation,
    useGetAPARAccrualsMutation,
    useGetARInvoiceExtractMutation,
    useGetAPARAccrualsExtractMutation,
    useGetProfitandLossReportMutation,
    useGetProfitandLossReportExtractMutation,
    useGetSpecificationReportDataMutation,
    useGetSpecificationChargesReportDataMutation,
    useGetARInvoiceApprovedExtractionSAPMutation,

}= arapreportsapi;